import i18n from '@/langs/i18n.js';

export default function () {
  return [
    {
      title: i18n.t('ui.pulpit'),
      to: '/pulpit',
      permissions: 'dashboard'
    },
    {
      title: i18n.t('ui.messages'),
      to: '/wiadomosci',
      permissions: 'messages',
      showCounter: true,
      counter: '0'
    },
    {
      title: i18n.t('client.clients'),
      to: '/klienci',
      permissions: 'customers'
    },
    {
      title: i18n.t('customer.customerCreditOffers'),
      titleMobile: i18n.t('ui.offers'),
      to: '/oferty-kredytowe',
      permissions: 'inquiries'
    },
    {
      title: i18n.t('ui.massCommunication'),
      titleMobile: i18n.t('ui.massCommunicationTitleMobile'),
      to: '/komunikacja',
      permissions: 'communication'
    },
    {
      title: i18n.t('ui.calendar'),
      to: '/kalendarz',
      permissions: 'calendar'
    },
    {
      title: i18n.t('ui.settlements'),
      to: '/rozliczenia',
      permissions: 'settlements'
    },
    {
      title: i18n.t('ui.settings'),
      to: '/ustawienia',
      permissions: 'settings'
    },
    {
      title: i18n.t('articleForm.articles'),
      to: '/artykuly',
      permissions: 'articles'
    },
    {
      title: i18n.t('promotions.promotions'),
      to: '/promocje',
      permissions: 'slots'
    },
    {
      title: i18n.t('advisersFinder.theFinanceExpert'),
      to: '/eksperci-finansowi',
      permissions: 'advisers',
      isMobileAppOnly: true
    },
    {
      title: i18n.t('ui.logout'),
      to: '/wyloguj',
      danger: true,
      isMobileAppOnly: true
    }
  ];
}
